const USER_PROFILE_PAGE_CONTANTS = {
  'SIGNIN_PAGE':'SIGNIN',
  'SIGNUP_PAGE':'SIGNUP',
  'RESET_PAGE': 'RESET',
  'RESET_CONFIRMATION_PAGE': 'RESET_CONFIRMATION',
  'SIGNEDIN_USER_PAGE': 'SIGNEDIN_USER',
  'SIGNUP_FORM_PAGE': 'SIGNUP_FORM',
}

export default USER_PROFILE_PAGE_CONTANTS